import {
  storeLandlordFile,
  deleteLandlordFile,
  getLandlordFiles
} from '@/services/appService';

async function addFile(ctx, { applicationId, file }) {
  const addedFile = await storeLandlordFile(applicationId, file);
  ctx.commit('add', { applicationId, file: addedFile });
}

async function removeFile(ctx, { applicationId, fileName }) {
  await deleteLandlordFile(applicationId, fileName);
  ctx.commit('remove', { applicationId, fileName });
}

async function getFiles(ctx, applicationId) {
  const files = await getLandlordFiles(applicationId);
  ctx.commit('set', { applicationId, files });
}

export default {
  addFile,
  removeFile,
  getFiles
};
